module.exports = __webpack_public_path__ + "static/media/medcabinet.ee2bb0c2.png";